var TorsoBehavior = require('backbone-torso/modules/Behavior');
var logoutInPlace = require('./logoutUtils').logoutInPlace;
var userService = require('./../user/userService');

/**
 * Behavior that logs out the user upon initialization
 *
 * @class LogoutIfLoggedInBehavior
 * @constructor
 * @extends Torso.Behavior
 */
module.exports = TorsoBehavior.extend({

  /**
   * @method initialize
   * @override
   */
  initialize: function() {
    userService.isAuthenticated()
      .then(logoutInPlace);
  }
});
